import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';

import { lighterYellow, gray, red, white } from 'utils/color-styles';
import { PageBannerContainer } from 'components/PageBannerContainer/PageBannerContainer';
import PayrollPageBanner from 'assets/pageBanners/payroll.avif';
import payrollHeader from 'assets/payroll-header.avif';
import { CurrencyCode, currencyFormat } from 'utils/currencyFormat';

export const PayrollHeader = () => (
  <PageBannerContainer
    color={lighterYellow}
    style={{ height: 'inherit', marginBottom: 0, position: 'relative', minHeight: '200px' }}
    backgroundImage={PayrollPageBanner}
  >
    <div
      style={{
        display: 'flex',
        gap: 10,
        flexDirection: 'row-reverse', // this allows the buttons to stay on top of metrics when wrapping
        flexWrap: 'wrap',
        flex: '1 1 auto',
        marginTop: 40,
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: 10,
          flexWrap: 'wrap',
          flex: '0 1 auto',
          justifyContent: 'flex-end',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            gap: 10,
          }}
        ></div>
      </div>

      <div
        style={{
          display: 'flex',
          gap: 10,
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          flex: '1 1 auto',
        }}
      >
        <h1 style={{ margin: 0, flex: '1 1 auto' }}>Payroll</h1>
      </div>
    </div>
  </PageBannerContainer>
);

type Props = {
  totalDeduction?: {
    intent: number;
    actual: number;
    currency: CurrencyCode;
  };
};

export const PayrollHeaderV1 = ({ totalDeduction }: Props) => (
  <Paper
    style={{
      padding: '28px 36px',
      marginBottom: 40,
      backgroundColor: white,
      backgroundImage: `url("${payrollHeader}")`,
      backgroundSize: 'contain',
      backgroundPositionX: '90%',
      minHeight: 200,
      borderRadius: 16,
    }}
  >
    {totalDeduction && (
      <>
        <Typography style={{ color: gray, marginBottom: 10, lineHeight: '30px' }}>
          Total deducted from Payroll
        </Typography>
        <Typography style={{ fontSize: 42, fontWeight: 'bold' }}>
          {currencyFormat(totalDeduction.actual, totalDeduction.currency)}
        </Typography>
        {totalDeduction.actual < totalDeduction.intent && (
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <WarningIcon style={{ color: red, marginRight: 10 }} />
            <Typography style={{ fontSize: 12, color: red }}>
              There is a total outstanding balance of -
              {currencyFormat(
                totalDeduction.intent - totalDeduction.actual,
                totalDeduction.currency
              )}{' '}
              that wasn&apos;t paid
            </Typography>
          </div>
        )}
      </>
    )}
  </Paper>
);
